import { ErrorHandler } from '@src/components/ErrorHandler';
import { useRoutesContext } from '@src/context/Routes';
import { Badge } from '@uhg-abyss/web/ui/Badge';
import { Divider } from '@uhg-abyss/web/ui/Divider';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
import { isEmpty, isUndefined } from 'lodash';
import React, { useEffect, useState } from 'react';

/**
 * Filters
 *
 * Displays applied filters for the work queue derived from the route in a removable chip format.
 *
 * @returns {Element}
 * @constructor
 */
export function Filters() {
  const { currentRoute } = useRoutesContext();
  const eid = currentRoute?.params?.eid;
  const policyNumber = currentRoute?.params?.policyNumber;

  const [filters, setFilters] = useState([]);

  /**
   * set the filters based on the route params
   */
  useEffect(() => {
    const theFilters = [];

    if (!isUndefined(eid)) {
      theFilters.push({
        label: 'eid',
        value: eid,
      });
    }

    if (!isUndefined(policyNumber)) {
      theFilters.push({
        label: 'policyNumber',
        value: policyNumber,
      });
    }

    if (theFilters !== filters) {
      setFilters(theFilters);
    }
  }, [eid, policyNumber]);

  if (isEmpty(filters)) {
    return null;
  }

  return (
    <ErrorHandler location="src/routes/private/WorkQueue/screens/List/components/Table/components/Header/components/Filters/Filters.jsx">
      <Layout.Group alignItems="bottom" alignLayout="left" css={{ height: '100%' }}>
        <Flex alignItems="center">
          <Text fontWeight="bold" size="sm">
            Filters:
          </Text>
          <Divider color="" height={16} margin="$xs" orientation="vertical" />
          {filters.map((filter) => {
            return (
              <Layout.Group alignItems="center" alignLayout="left" key={filter.label}>
                <Badge rounded variant="neutral">
                  <Layout.Group alignItems="center" alignLayout="left">
                    <Text fontWeight="bold" size="xs">
                      {filter.label}:
                    </Text>
                    <Text fontWeight="normal" size="xs">
                      {filter.value}
                    </Text>
                  </Layout.Group>
                </Badge>
                <Divider color="" height={16} margin="0px" orientation="vertical" width={1} />
              </Layout.Group>
            );
          })}
        </Flex>
      </Layout.Group>
    </ErrorHandler>
  );
}
